<template>
  <div style="box-shadow: 0 0 0 0 !important" class="adminGraph">
    <v-row justify="center" class="mt-5 graphContent" style="margin: 0px">
      <DailyReportFilter @handleFilter="handleFilter" />
    </v-row>

    <div v-if="!getDataDone">
      <!-- Date Range Display -->
      <div v-if="reportData.startDate" class="mt-4 mb-4">
        <v-row>
          <v-col cols="12" md="6">
            <label class="font-weight-bolder h5">
              <span>التاريخ من</span>: {{ reportData.startDate }}
            </label>
          </v-col>
          <v-col cols="12" md="6">
            <label class="font-weight-bolder h5">
              <span>التاريخ الى</span>: {{ reportData.endDate }}
            </label>
          </v-col>
        </v-row>
      </div>

      <!-- Table -->
      <table-component
        v-if="reportLoaded"
        itemKey="id"
        :headers="tableHeaders"
        :formBody="body"
        :pagination="pagination"
        :limit="$store.state.counterOfShow"
        :items="tableData"
        :loading="loading"
        v-model="page"
        style="margin-bottom: 30px"
      />

      <!-- Legend -->
      <div v-if="reportData.chartUsers && reportData.chartUsers.length" class="mb-4">
        <div class="legend-container">
          <div class="legend-item">
            <div class="legend-color color-green"></div>
            <div>{{ reportData.sum_of_new_requests }}</div>
            <div>الطلبات الجديدة</div>
          </div>
          <div class="legend-item">
            <div class="legend-color color-blue"></div>
            <div>{{ reportData.sum_of_transferred_requests }}</div>
            <div>الطلبات المحولة</div>
          </div>
          <div class="legend-item">
            <div class="legend-color color-red"></div>
            <div>{{ reportData.total_sum }}</div>
            <div>مجموع الطلبات</div>
          </div>
        </div>
      </div>

      <!-- Chart Container -->
      <div v-if="reportData.chartUsers && reportData.chartUsers.length">
        <div id="chart-container" style="width:100%; height:500px;"></div>
      </div>

      <div v-if="reportLoaded && !loading && reportData.chartUsers && reportData.chartUsers.length === 0 && tableData.length === 0" class="text-center mt-4">
        <p>لا يوجد نتائج</p>
      </div>
    </div>
    <div v-else class="loader">
      <img src="../../../../assets/Comp-2.gif" />
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import Highcharts from "highcharts";
import DailyReportFilter from "@/views/admin/Charts/DailyReportFilter.vue";
import TableComponent from "@/components/Base/TableComponent.vue";

export default {
  name: "RequestsReceivedReport",
  components: {
    DailyReportFilter,
    TableComponent,
  },
  data() {
    return {
      loading: false,
      getDataDone: false,
      reportLoaded: false,
      reportTotals: {
        sum_of_new_requests: 0,
        sum_of_transferred_requests: 0,
        total_sum: 0,
      },
      reportData: {},
      tableData: [],
      tableHeaders: [
        { text: "الإستشاري", value: "الإستشاري", align: "center", width: "170px" },
        { text: "الطلبات الجديدة", value: "الطلبات الجديدة", align: "center" },
        { text: "الطلبات المحولة", value: "الطلبات المحولة", align: "center" },
        { text: "المجموع", value: "المجموع", align: "center" },
      ],
      page: 1,
      body: {},
      pagination: {},
    };
  },
  watch: {
    page(val) {
      this.getData(val, "loading");
    },
    "$store.state.counterOfShow": {
      handler(newval, oldvalue) {
        if (newval !== oldvalue && !this.$store.state.admin_search_active) {
          this.getData(this.page, "loading");
        }
      },
    },
  },
  methods: {
    showPopup(type, message) {
      this.$store.commit("showPopup", { type, message });
    },
    handleFilter(filterData) {
      this.body = new FormData();

      const managerIds = filterData.managerId || [];
      const agentIds = filterData.agentId || [];
      let status_user = 1;
      if (filterData.status === 'الكل' || filterData.status === '2') {
        status_user = 2;
      } else if (filterData.status === 'استشاري مؤرشف' || filterData.status === '0') {
        status_user = 0;
      } else if (filterData.status === 'استشاري قائم' || filterData.status === '1' || !filterData.status || filterData.status === '') {
        status_user = 1;
      }

      if (filterData.startDate) {
        this.body.append("start_date", filterData.startDate);
      }

      if (filterData.endDate) {
        this.body.append("end_date", filterData.endDate);
      }

      const hasExplicitDates = filterData.startDate && filterData.endDate;

      if (!hasExplicitDates && filterData.range) {
        this.body.append("range", filterData.range);
      }

      if (!hasExplicitDates && filterData.dayNumber !== '' && filterData.dayNumber != null) {
        const days = Number(filterData.dayNumber);
        this.body.append("range", days === 1 ? "day" : filterData.dayNumber);
      }

      this.body.append("status_user", status_user);

      if (managerIds && managerIds.length > 0) {
        managerIds.forEach((item, index) => {
          const managerId = typeof item === 'object' ? item.id : item;
          this.body.append(`manager_id[${index}]`, managerId);
        });
      }

      if (agentIds && agentIds.length > 0) {
        agentIds.forEach((item, index) => {
          const agentId = typeof item === 'object' ? item.id : item;
          this.body.append(`adviser_id[${index}]`, agentId);
        });
      }

      this.page = 1;
      this.getData(1, "getDataDone");
    },
    getData(page, loader) {
      if (loader === "getDataDone") {
        this.getDataDone = true;
      } else if (loader === "loading") {
        this.loading = true;
      }

      const withTotals = loader === "getDataDone" || page === 1 ? 1 : 0;
      const url = `${this.$store.state.url}/employee/admin/requests-received-report?page=${page}&per_page=${this.$store.state.counterOfShow}&with_totals=${withTotals}`;

      Axios.post(url, this.body, { headers: this.request_headers() })
        .then((response) => {
          const payload = response.data.payload || {};

          if (payload.with_totals && payload.sum_of_new_requests != null) {
            this.reportTotals = {
              sum_of_new_requests: payload.sum_of_new_requests ?? 0,
              sum_of_transferred_requests: payload.sum_of_transferred_requests ?? 0,
              total_sum: payload.total_sum ?? 0,
            };
          }

          this.reportData = {
            ...payload,
            ...this.reportTotals,
          };
          this.tableData = payload.data || [];
          this.reportLoaded = true;

          this.pagination = {
            count: response.data.payload.total_agents || 0,
          };

          // Render chart after a short delay to ensure DOM is ready
          setTimeout(() => {
            this.renderChart();
          }, 100);
        })
        .catch((error) => {
          console.error("Error loading report:", error);
          this.showPopup("error", "حدث خطأ أثناء تحميل التقرير");
        })
        .finally(() => {
          this.loading = false;
          this.getDataDone = false;
        });
    },
    renderChart() {
      if (!this.reportData.chartUsers || this.reportData.chartUsers.length === 0) {
        return;
      }

      // Destroy existing chart if it exists
      const existingChart = Highcharts.charts.find(chart => chart && chart.renderTo.id === 'chart-container');
      if (existingChart) {
        existingChart.destroy();
      }

      // Wait for DOM to be ready
      this.$nextTick(() => {
        const chartContainer = document.getElementById('chart-container');
        if (!chartContainer) {
          console.warn('Chart container not found');
          return;
        }

        Highcharts.chart('chart-container', {
          chart: {
            type: 'column'
          },
          title: {
            text: 'تقرير الطلبات المستلمة'
          },
          xAxis: {
            categories: this.reportData.chartUsers,
          },
          yAxis: {
            min: 0,
            title: {
              text: 'عدد الطلبات'
            },
            stackLabels: {
              enabled: true,
              style: {
                fontWeight: 'bold',
                color: (Highcharts.defaultOptions.title.style &&
                  Highcharts.defaultOptions.title.style.color) || 'gray'
              }
            }
          },
          legend: {
            align: 'right',
            x: -30,
            verticalAlign: 'top',
            y: 25,
            floating: true,
            backgroundColor: Highcharts.defaultOptions.legend.backgroundColor || 'white',
            borderColor: '#CCC',
            borderWidth: 1,
            shadow: false
          },
          tooltip: {
            headerFormat: '<b>{point.x}</b><br/>',
            pointFormat: '{series.name}: {point.y}<br/>المجموع: {point.stackTotal}'
          },
          plotOptions: {
            column: {
              stacking: 'normal',
              dataLabels: {
                enabled: true
              }
            }
          },
          series: [
            {
              name: 'الطلبات المحولة',
              color: '#007bff',
              data: this.reportData.chartValuesTransferred || []
            },
            {
              name: 'الطلبات الجديدة',
              color: 'green',
              data: this.reportData.chartValuesNew || []
            },
          ]
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.legend-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  background-color: #f9f9f9;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  margin: 20px 0;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  flex-direction: column;
}

.legend-color {
  width: 15px;
  height: 15px;
  border-radius: 50%;
}

.color-blue {
  background-color: #007bff;
}

.color-green {
  background-color: green;
}

.color-red {
  background-color: red;
}

.v-input__control {
  min-height: 40px !important;
}

.label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}
</style>
